import { render, staticRenderFns } from "./productDetails.vue?vue&type=template&id=6c73d425&scoped=true"
import script from "./productDetails.vue?vue&type=script&lang=js"
export * from "./productDetails.vue?vue&type=script&lang=js"
import style0 from "./productDetails.vue?vue&type=style&index=0&id=6c73d425&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c73d425",
  null
  
)

export default component.exports